interface FieldErrorProps {
  message?: string;
}

const FieldError = ({ message }: FieldErrorProps) => {
  if (!message) return null;
  return (
    <span role="alert" className="text-xsss font-medium text-orange-700">
      {message}
    </span>
  );
};

export default FieldError;
